import { render, staticRenderFns } from "./dataTag.vue?vue&type=template&id=09c73e4b&scoped=true&"
import script from "./dataTag.vue?vue&type=script&lang=js&"
export * from "./dataTag.vue?vue&type=script&lang=js&"
import style0 from "./dataTag.vue?vue&type=style&index=0&id=09c73e4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c73e4b",
  null
  
)

export default component.exports